import { render, staticRenderFns } from "./taskDates.vue?vue&type=template&id=4f324061&"
import script from "./taskDates.vue?vue&type=script&lang=js&"
export * from "./taskDates.vue?vue&type=script&lang=js&"
import style0 from "./taskDates.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports